import React from 'react';
import { Container } from 'react-bootstrap';
import profiles from '../../data/profiles/profiles.json';
import { Profile } from  '../../types';
import UserCard from './UserCard';
import UserCardGrouped from './UserCardGrouped';
import UserDefaultCard from './UserDefaultCard';

function UserCardsDemo() {
  const demoProfiles = profiles.data;

  const childProfiles = demoProfiles.filter((profile: Profile) => profile.relationship === 'child');
  const nonChildProfiles = demoProfiles.filter((profile: Profile) => profile.relationship !== 'child');
  const profilesItems = childProfiles.length > 1 ? nonChildProfiles : demoProfiles;

  return (
    <Container className="p-0">
      <Container className="p-0 mt-10 d-flex flex-wrap">
        {profilesItems.map((profile: Profile, index) => (
          <UserCard
          item={profile}
          key={index}
          className={'mb-7 mb-lg-0 me-lg-7'}
          />
        ))}
        {childProfiles.length > 1 && (<UserCardGrouped avatars={childProfiles} value={'children'} className={'mb-7 mb-lg-0 me-lg-7'}/>)}
        <UserDefaultCard />
      </Container>
    </Container>
  );
}

export default UserCardsDemo;
